import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, Form, Input, Label } from 'reactstrap';
import { forgotPassword, forgotPasswordForm, setForgotPasswordConfirmationStatus } from '../../store/actions';

const Recover = (props) => {
  const [email, setEmail] = useState('');
  const { confirmationStatus } = props;
  const credits = window.__ENV && window.__ENV.credits;
  useEffect(() => {
    props.setForgotPasswordConfirmationStatus('');
  }, []);

  const validateOnChange = (event) => {
    const { name, value } = event.target;
    props.forgotPasswordForm({ ...props.formforgot, [name]: value })
  };

  const onSubmit = (e) => {
    e.preventDefault();
    props.forgotPassword(email);
  };


  return (
    <div className="page-content">
      <Form>
        <Label htmlFor="email">Email</Label>
        <Input type="email" name="email" id="email" onChange={validateOnChange} />
        <Button color="primary" onClick={onSubmit}>Recover password</Button>
        <div className="position-absolute bottom-0 start-50 translate-middle-x mt-5 text-center">
          <p className="text-white-50">
            © {new Date().getFullYear()} {credits}.
          </p>
        </div>
      </Form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  formforgot: state.login.formforgot,
  confirmationStatus: state.login.confirmationStatus,
});

const mapDispatchToProps = (dispatch) => ({
  forgotPasswordForm: (formforgot) => dispatch(forgotPasswordForm(formforgot)),
  forgotPassword: (email) => dispatch(forgotPassword(email)),
  setForgotPasswordConfirmationStatus: (status) => dispatch(setForgotPasswordConfirmationStatus(status))
});

export default connect(mapStateToProps, mapDispatchToProps)(Recover);




